import { render } from "./OrderTypeTabs.vue?vue&type=template&id=5480927a"
import script from "./OrderTypeTabs.vue?vue&type=script&lang=js"
export * from "./OrderTypeTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__